export interface Spedizione {
    "codice": number,
    "descrizione": string,
    "prezzo": number,
    "percentuale": number,
    "min_ordine": number,
    "max_ordine": number,
    "tipo_spedizione": tipo_spedizione,
    "lead_time_spedizione": number,
    "canale": canale,
    "condizione_articoli": boolean
}

type tipo_spedizione = 0 | 1 | 2;
type canale = 0 | 1;

const TIPI_SPEDIZIONE = ['Corriere', 'Ritiro in negozio', 'Consegna a domicilio'];

export function getTipoSpedizioneStr(tipo_spedizione) {
    return TIPI_SPEDIZIONE[tipo_spedizione];
}

const TIPI_SPEDIZIONE_FB = ['Corriere', 'Ritiro In Negozio', 'Domicilio'];

export function getTipoSpedizioneFBStr(tipo_spedizione) {
    return TIPI_SPEDIZIONE_FB[tipo_spedizione];
}